import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/GlobalErrorHandlerInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DiagnosticsProvider"] */ "/vercel/path0/src/contexts/DiagnosticsContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/tailwind.css");
